import { Smile } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import { EMOJI_CATEGORIAS } from '@/lib/emojis';

interface EmojiGridProps {
  onSelect: (emoji: string) => void;
}

// Grelha pura (sem Popover) — exportada para teste determinístico.
export function EmojiGrid({ onSelect }: EmojiGridProps) {
  return (
    <div className="emoji-grid">
      {EMOJI_CATEGORIAS.map((cat) => (
        <div key={cat.icone} className="emoji-grid__cat">
          <div className="emoji-grid__row">
            {cat.emojis.map((e) => (
              <button
                key={e}
                type="button"
                className="emoji-grid__btn"
                aria-label={e}
                onClick={() => onSelect(e)}
              >
                {e}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  onOpenChange?: (open: boolean) => void;
  disabled?: boolean;
}

export function EmojiPicker({ onSelect, onOpenChange, disabled }: EmojiPickerProps) {
  return (
    <Popover onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <button type="button" aria-label="emoji" disabled={disabled}>
          <Smile size={15} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-72 max-h-64 overflow-y-auto p-2"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <EmojiGrid onSelect={onSelect} />
      </PopoverContent>
    </Popover>
  );
}
